import { effectScope, watch } from "./vue/dist/vue.runtime.esm-bundler.js";
import { theme as currentTheme } from "./theme.ts";
let widgets;
function loadWidgets() {
	widgets ?? (widgets = new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = "https://platform.twitter.com/widgets.js";
		script.async = true;
		script.onload = () => window.twttr?.ready(resolve);
		script.onerror = reject;
		document.head.append(script);
	}));
	return widgets;
}
async function embed(post, theme) {
	const link = post.querySelector(":scope > blockquote > p:last-child > a:last-child");
	const id = link?.pathname.match(/\/status\/(\d+)/)?.[1];
	if (!id) return;
	post.classList.add("is-loading");
	let rendered;
	const target = document.createElement("div");
	target.className = "x-post-loading";
	try {
		const twttr = await loadWidgets();
		post.append(target);
		rendered = await twttr.widgets.createTweet(id, target, {
			theme,
			dnt: true,
			conversation: "none"
		});
	} finally {
		post.classList.remove("is-loading");
	}
	// A newer theme may have started another embed meanwhile; keep only the latest.
	if (!rendered || currentTheme.value !== theme) {
		target.remove();
		return;
	}
	post.querySelector(":scope > blockquote")?.setAttribute("hidden", "");
	post.querySelector(":scope > [data-x-embed]")?.remove();
	target.className = "";
	target.dataset.xEmbed = "";
}
const scope = effectScope();
scope.run(() => {
	for (const post of document.querySelectorAll(".x-post")) {
		watch(currentTheme, (value) => void embed(post, value).catch(() => {}), { immediate: true });
	}
});
if (import.meta.hot) import.meta.hot.dispose(() => scope.stop());
